import axios, { AxiosResponse } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { SubmitBriefRequestData } from './submitBrief';

export type EditBriefRequestData = Partial<SubmitBriefRequestData>;

export interface EditBriefResponse {
    success: boolean;
}

export interface EditBriefParams {
    briefId: string;
    requestData: EditBriefRequestData;
    requestExtraWave?: boolean;
}

export const editBrief = async ({ briefId, requestData, requestExtraWave }: EditBriefParams) => {
    const url = pathfinder('edit_dm_brief', { brief_id: briefId });
    const urlWithParams = requestExtraWave ? `${url}?request_extra_wave=true` : url;

    return axios.post<EditBriefResponse, AxiosResponse<EditBriefResponse>, EditBriefRequestData>(
        urlWithParams,
        requestData
    );
};
